
import { defineComponent } from 'vue'
import TheHeader from '@/common/components/TheHeader.vue'
import TheSidebar from '@/common/components/TheSidebar.vue'
import TheContent from '@/common/components/TheContent.vue'
import TheMain from '@/common/components/TheMain.vue'

export default defineComponent({
    name: 'AppLayoutDashboard',
    components: {
        TheHeader,
        TheSidebar,
        TheContent,
        TheMain,
    },
})
